import useSWR, { SWRResponse } from "swr";
import { IUsePowerOfAttorney } from "./types";
import useAdvisor from "../useAdvisor";
import commonSwrConfig from "../commonSwrConfig";
import { IPoaInfo } from "@portal/types/api/IPoaInfo";
import { useSession } from "@portal/auth/client/SessionProvider";
import { commonFetcher } from "../common/commonFetcher";

const usePowerOfAttorney: IUsePowerOfAttorney = () => {
  const { update } = useSession();
  const { isAdvisorAndNoImpersonation } = useAdvisor();

  const { data, error, isLoading }: SWRResponse<IPoaInfo[], unknown> = useSWR(
    !isAdvisorAndNoImpersonation ? "/api/power-of-attorney" : null,
    commonFetcher<IPoaInfo[]>,
    commonSwrConfig(update),
  );

  return {
    data,
    isLoading,
    error,
  };
};

export default usePowerOfAttorney;
